import axios from 'axios';

export const apiErrorResponse = (error) => {
	if (error.response) {
		console.log(error.response.data);
		console.log(error.response.status);
		console.log(error.response.headers);
	} else if (error.request) {
		console.log(error.request);
	} else {
		console.log('Error', error.message);
	}
};

const instance = axios.create({
	// baseURL: 'http://localhost:3000',
	// baseURL: 'https://staging-api.omnom.food',
	baseURL: 'https://api.omnom.food',
	withCredentials: true
});

instance.interceptors.request.use(
	(config) => {
		const accessToken = localStorage.getItem('accessToken');

		if (accessToken) {
			config.headers = {
				Authorization: `Bearer ${accessToken}`,
				Accept: 'application/json'
			};
		}

		return config;
	},
	(err) => Promise.reject(err)
);

instance.interceptors.response.use(
	(response) => response,
	(error) => {
		apiErrorResponse(error);

		return Promise.reject(error);
	}
);

export default instance;
